module.exports = __webpack_public_path__ + "img/img-2-mobile.fd5054b7.png";